/* Въпросникът-навигатор: три стъпки до продукти.
 *
 * Стъпка 1 - главна област (радио плочки; стойността е дръжката на записа);
 * стъпка 2 - подобласти на избраната (до 3 отметки; всяка е реална колекция);
 * стъпка 3 - формите на избраната област (панел на област, една или няколко);
 * резултат - Section Rendering API на t4-kviz-rezultat за всяка избрана
 * подобласт, слети карти, Билков рай(R) напред, до N (настройка), плюс
 * „Виж всички в ..." за всяка подобласт. Закачените продукти на подобластта
 * („Първо покажи тези") излизат отпред, скритите („Никога не показвай тук") -
 * не излизат за нея (вариант А, Симеон 01.10.2026).
 *
 * Данните - текстовете, билките, имената за подредбата - идват от дървото
 * метаобекти „Въпросник" като JSON в [data-br-kviz-tekstove], по дръжка
 * на подобластта и на формата, не по име (01.10.2026).
 *
 * Без този скрипт секцията показва стъпки 1-2 като статични списъци с
 * връзки към колекциите - никога празна страница.
 */
(function () {
  'use strict';

  var koren = document.querySelector('[data-br-kviz]');
  if (!koren || !window.fetch || !window.DOMParser) return;

  var MAX_POD = 3;
  var BROY = parseInt(koren.dataset.broy, 10) || 12;
  var MARKA = 'Билков рай®';   /* данни, не текст: по него се подреждат картите */

  /* Текстовете, които скриптът пише сам, идват от Настройки на темата → Въпросник
     (data-t-* върху [data-br-kviz]). Втората стойност е само резерва за стара
     кеширана страница без атрибута. */
  function t(kluch, rezerva) {
    var v = koren.dataset[kluch];
    return (v === undefined || v === '') ? rezerva : v;
  }
  var T_NAPRED = t('tNapred', 'Напред');
  var T_POKAZHI = t('tPokazhi', 'Покажи продуктите');
  var T_TARSYA = t('tTarsya', 'Търся…');
  var T_STAPKA = t('tStapka', 'Стъпка {n} от 3');
  var T_IZBRA = t('tIzbra', 'Избра {imena}.');
  var T_POKAZVAME = t('tPokazvame', 'Показваме {broy} продукта в избраните форми: {formi}.');
  /* „Виж всички“ е бутон, а името на подобластта - текст след него (Наталия, 16.10) */
  var T_VIZH_BUTON = t('tVizhButon', 'Виж всички');
  var T_VIZH = t('tVizh', 'в „{ime}“');
  var T_SV1 = t('tSv1', 'най-често се търсят');
  var T_SV2 = t('tSv2', 'най-подходящи са билките');
  var T_SV_KRAY = t('tSvKray', 'влизат в състава на продуктите по-долу');

  /* скриптът е жив: показваме интерактивното, скриваме резервните връзки */
  koren.querySelectorAll('[data-br-kviz-samo-js]').forEach(function (el) { el.hidden = false; });
  koren.querySelectorAll('[data-br-kviz-bez-js]').forEach(function (el) { el.hidden = true; });

  var napredak = koren.querySelector('[data-br-kviz-napredak]');
  var pale = koren.querySelector('[data-br-kviz-pale]');
  var tekst = koren.querySelector('[data-br-kviz-tekst]');
  var butonNapred = koren.querySelector('[data-br-napred]');
  var butonNazad = koren.querySelector('[data-br-nazad]');
  var rezultat = koren.querySelector('[data-br-kviz-rezultat]');
  var grid = koren.querySelector('[data-br-kviz-grid]');
  var vsichki = koren.querySelector('[data-br-kviz-vsichki]');
  var prazno = koren.querySelector('[data-br-kviz-prazno]');

  var stapka = 1;

  /* ИЗМЕРВАНЕТО (19.10.2026, Симеон: „дали се използва, колко пъти, как и защо“) - към GA4 през br-ga4
     (window.brAnalitika.kviz); без него - нищо. kviz_stapka е току-що минатата стъпка; изборите са с имената,
     които човекът вижда. Грешка тук не бива да спре въпросника. */
  function izbor() {
    var r = koren.querySelector('input[name="br-glavna"]:checked');
    return {
      kviz_oblast: r ? (r.dataset.brGlavnaIme || r.value) : '',
      kviz_podoblasti: izbraniPod().map(function (p) { return p.etiket; }).filter(Boolean).join(', ').slice(0, 100),
      kviz_formi: izbraniFormi().map(function (f) { return f.etiket || f.tekst; }).filter(Boolean).join(', ').slice(0, 100)
    };
  }
  function analitika(ime, dop) {
    try {
      var a = window.brAnalitika;
      if (a && a.kviz) a.kviz(ime, Object.assign(izbor(), dop || {}));
    } catch (e) { /* измерването не спира въпросника */ }
  }

  /* ПАМЕТ НА ВЪПРОСНИКА (Наталия, 14.09: „то те връща на началото").
     Досега стъпката живееше само в тази променлива. Отидеш ли до продукт и се
     върнеш, страницата се зарежда наново, нищо не е отметнато и „Напред" стои
     изключен - точно каквото ѝ се случи. sessionStorage преживява връщането
     назад, важи само за този раздел на браузъра и умира със затварянето му. */
  var KLIUCH = 'br-kviz:' + location.pathname;
  var ZHIVOT = 6 * 60 * 60 * 1000;   /* шест часа - след това започваме начисто */
  var vazstanovyavam = false;

  function zapishi() {
    if (vazstanovyavam) return;
    try {
      sessionStorage.setItem(KLIUCH, JSON.stringify({
        s: stapka,
        g: izbranaGlavna(),
        p: Array.prototype.slice.call(koren.querySelectorAll('input[name="br-pod"]:checked')).map(function (ch) { return ch.value; }),
        f: izbraniFormi().map(function (f) { return f.parametri; }),
        v: Date.now()
      }));
    } catch (e) { /* частен режим: губим паметта, но не и въпросника */ }
  }

  function zabravi() {
    try { sessionStorage.removeItem(KLIUCH); } catch (e) {}
  }

  function otmetni(koren2, ime, stoynosti) {
    var brojach = 0;
    koren2.querySelectorAll('input[name="' + ime + '"]').forEach(function (ch) {
      if (stoynosti.indexOf(ch.value) >= 0) { ch.checked = true; brojach++; }
    });
    return brojach;
  }

  function vazstanovi() {
    var syrovo;
    try { syrovo = sessionStorage.getItem(KLIUCH); } catch (e) { return false; }
    if (!syrovo) return false;
    var d;
    try { d = JSON.parse(syrovo); } catch (e) { zabravi(); return false; }
    if (!d || !d.g || !d.v || (Date.now() - d.v) > ZHIVOT) { zabravi(); return false; }

    vazstanovyavam = true;
    try {
      var ima = otmetni(koren, 'br-glavna', [d.g]);
      if (!ima) { zabravi(); return false; }
      /* Отметките на стъпки 2 и 3 се връщат САМО в панелите на своята главна
         област: една форма стои в няколко области със същата стойност - търсене
         из целия въпросник би отметнало и чуждата. */
      var panel = koren.querySelector('[data-br-stapka="2"][data-br-za="' + d.g + '"]');
      if (panel) { otmetni(panel, 'br-pod', d.p || []); limitPod(panel); }
      var panel3 = koren.querySelector('[data-br-stapka="3"][data-br-za="' + d.g + '"]');
      if (panel3) otmetni(panel3, 'br-forma', d.f || []);
    } finally {
      vazstanovyavam = false;
    }

    stapka = Math.min(Math.max(parseInt(d.s, 10) || 1, 1), 4);
    if (stapka >= 3 && !izbraniPod().length) stapka = 2;
    if (stapka === 4 && !izbraniFormi().length) stapka = 3;
    return true;
  }

  function kamVaprosnika() {
    var cel = koren.closest('#vaprosnik') || koren;
    cel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function paneli2() {
    return Array.prototype.slice.call(koren.querySelectorAll('[data-br-stapka="2"]'));
  }

  function paneli3() {
    return Array.prototype.slice.call(koren.querySelectorAll('[data-br-stapka="3"]'));
  }

  function aktivenPanel3() {
    return koren.querySelector('[data-br-stapka="3"][data-br-za="' + izbranaGlavna() + '"]');
  }

  function izbranaGlavna() {
    var r = koren.querySelector('input[name="br-glavna"]:checked');
    return r ? r.value : null;
  }

  function izbraniPod() {
    var aktiven = koren.querySelector('[data-br-stapka="2"][data-br-za="' + izbranaGlavna() + '"]');
    if (!aktiven) return [];
    return Array.prototype.slice.call(aktiven.querySelectorAll('input[name="br-pod"]:checked'))
      .map(function (ch) {
        /* стойността е дръжката на подобластта (две подобласти могат да делят
           колекция); колекциите са в data-drazhki - първата е за „Виж всички",
           всичките дават резултата; data-cel е стойността ѝ в „Цел" */
        var vsichki = (ch.dataset.drazhki || '').split(',').filter(Boolean);
        return { kluch: ch.value, drazhka: vsichki[0] || '', etiket: ch.dataset.etiket,
                 cel: ch.dataset.cel || ch.dataset.etiket, vsichki: vsichki };
      });
  }

  /* Формите са МНОЖЕСТВЕН избор (Наталия, 14.09). Shopify чете повтарящ се
     filter.p.m.custom.forma като ИЛИ, затова параметрите просто се слепват. */
  function izbraniFormi() {
    /* само в панела на избраната област - отметка от друга област остава в
       своя скрит панел и не влиза в адреса */
    var panel = aktivenPanel3();
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('input[name="br-forma"]:checked'))
      .map(function (ch) {
        return { parametri: ch.value,
                 tekst: ch.dataset.brTekst || '',
                 kluch: ch.dataset.brFormaHandle || '',
                 etiket: ch.dataset.brFormaEtiket || '' };
      });
  }

  function formaParametri() {
    return izbraniFormi().map(function (f) { return f.parametri; }).filter(Boolean).join('&');
  }

  /* Формите по ОБЛАСТ (Симеон, 22.09) са в записа на областта („Въпрос 3 -
     формите"); темата рисува по един панел на област. Старото криене по ИМЕ на
     областта (data-br-forma-oblasti) отпадна на 01.10.2026 - преименувана
     област губеше формите си без нито едно съобщение. */

  function pokazhi() {
    koren.querySelector('[data-br-stapka="1"]').hidden = stapka !== 1;
    paneli2().forEach(function (p) {
      p.hidden = !(stapka === 2 && p.dataset.brZa === izbranaGlavna());
    });
    paneli3().forEach(function (p) {
      p.hidden = !(stapka === 3 && p.dataset.brZa === izbranaGlavna());
    });
    rezultat.hidden = stapka !== 4;
    napredak.hidden = stapka === 4;
    butonNazad.hidden = stapka === 1;
    butonNazad.parentElement.hidden = stapka === 4;

    if (stapka < 4) {
      pale.style.width = (stapka / 3 * 100) + '%';
      tekst.textContent = T_STAPKA.replace('{n}', stapka);
    }
    butonNapred.textContent = stapka === 3 ? T_POKAZHI : T_NAPRED;
    prover();
  }

  function prover() {
    var gotovo = false;
    if (stapka === 1) gotovo = !!izbranaGlavna();
    if (stapka === 2) gotovo = izbraniPod().length > 0;
    if (stapka === 3) gotovo = izbraniFormi().length > 0;
    butonNapred.disabled = !gotovo;
  }

  /* до 3 отметки: при пълна бройка останалите замръзват */
  function limitPod(panel) {
    var vs = panel.querySelectorAll('input[name="br-pod"]');
    var br = panel.querySelectorAll('input[name="br-pod"]:checked').length;
    vs.forEach(function (ch) { if (!ch.checked) ch.disabled = br >= MAX_POD; });
  }

  koren.addEventListener('change', function (e) {
    if (e.target.name === 'br-pod') limitPod(e.target.closest('[data-br-stapka="2"]'));
    if (e.target.name === 'br-glavna' && stapka === 1) {
      /* избор на плочка минава напред сам - един клик по-малко */
      stapka = 2;
      pokazhi();
      zapishi();
      analitika('kviz_stapka', { kviz_stapka: 1 });
      return;
    }
    prover();
    zapishi();
  });

  butonNapred.addEventListener('click', function () {
    if (stapka === 3) { analitika('kviz_stapka', { kviz_stapka: 3 }); pokazhiRezultat(); return; }
    var minata = stapka;
    stapka += 1;
    pokazhi();
    zapishi();
    analitika('kviz_stapka', { kviz_stapka: minata });
  });

  butonNazad.addEventListener('click', function () {
    if (stapka > 1) stapka -= 1;
    pokazhi();
    zapishi();
    /* без това плочките остават извън екрана и изглежда, че бутонът не работи
       (Наталия, 14.09: „трябва да излезеш отдолу под екрана") */
    kamVaprosnika();
  });

  koren.querySelector('[data-br-otnachalo]').addEventListener('click', function () {
    mahniRezerva();
    koren.querySelectorAll('input').forEach(function (ch) { ch.checked = false; ch.disabled = false; });
    grid.innerHTML = '';
    vsichki.innerHTML = '';
    stapka = 1;
    pokazhi();
    zabravi();
    kamVaprosnika();
  });

  function adres(drazhka, sSekcia) {
    var forma = formaParametri();
    /* БЕЗ sort_by (Симеон, 12.09): параметърът ПРЕГАЗВА подредбата на самата
       колекция. Всичките 35 колекции, до които води въпросникът, са с ръчна
       подредба - първо Билков рай, после по реални продажби. Със
       „sort_by=best-selling" третият резултат при Имунитет беше чужд сироп.
       Без параметъра Shopify ползва подредбата на колекцията и Билков рай
       излиза пръв при всяка комбинация, включително при филтър по форма. */
    return '/collections/' + drazhka + '?'
      + (forma ? forma + '&' : '')
      + (sSekcia ? 'section_id=t4-kviz-rezultat' : '');
  }

  /* „защо е тук": подобластите, които са го довели (удебелено), после целите
     на продукта от метаполето custom.cel (data-celi). Ограничен до 2 реда с CSS. */
  function dobaviZashto(el, etiketi, celiIzbrani) {
    var tyalo = el.querySelector('.t4-karta__tyalo');
    if (!tyalo) return;
    var celi = (el.dataset.celi || '').split('|').filter(Boolean);
    var zashto = document.createElement('p');
    zashto.className = 'br-kviz__zashto';
    var b = document.createElement('b');
    b.textContent = etiketi.join(', ');
    zashto.appendChild(b);
    var izkl = celiIzbrani || etiketi;
    var drugi = celi.filter(function (c) { return izkl.indexOf(c) < 0; }).slice(0, 3);
    if (drugi.length) zashto.appendChild(document.createTextNode(' · ' + drugi.join(' · ')));
    var sled = el.querySelector('.t4-karta__red') || el.querySelector('.t4-karta__ime');
    if (!sled) { tyalo.insertBefore(zashto, tyalo.firstChild); }
    else { sled.insertAdjacentElement('afterend', zashto); }
    /* без ред от описанието: първите му абзаци са името с главни букви и
       „Хранителна добавка / Без лекарско предписание" - шум, не полза */
  }

  /* текстът за съчетанието област x форма - пише се в блока на областта */
  var butonNazadRez = koren.querySelector('[data-br-nazad-rez]');
  if (butonNazadRez) {
    butonNazadRez.addEventListener('click', function () {
      stapka = 3;
      pokazhi();
      zapishi();
      kamVaprosnika();
    });
  }

  /* Изрежда списък по български: „а, б и в" */
  function izbroj(spisak) {
    var s = spisak.filter(Boolean);
    if (!s.length) return '';
    if (s.length === 1) return s[0];
    return s.slice(0, -1).join(', ') + ' и ' + s[s.length - 1];   /* граматика */
  }

  /* Слотовете на текстовете са изборът „Кой текст на подобластта показва" в
     записа на формата - данни, не текст: по тях се избира изречението. */
  var SLOT_EDINICHNA = 'Единична билка';   /* данни, не текст */
  var SLOT_KOMBINACII = 'Билкови комбинации';   /* данни, не текст */
  var SLOT_KAPSULI = 'Капсули и таблетки';   /* данни, не текст */

  /* Свързващият текст при няколко избрани подобласти - билките на Наталия за
     всяка от тях (полето „Билките" на подобластта, един списък за всички форми).
     Насипни: „За X най-често се търсят A, B и C, а за Y - D и E."
     Другите форми: „За X най-подходящи са билките A и B, а за Y - C - влизат в
     състава на продуктите по-долу." Подобласт без списък се пропуска; при
     капсулите и „Без билките при капсулите" (Коса, Кожа) - също. */
  function svarzvasht(karta, izbrani, slot) {
    var pd = (karta && karta.p) || {};
    var chasti = [];
    izbrani.forEach(function (p) {
      var d = pd[p.kluch];
      var z = d ? ((slot === SLOT_KAPSULI && d.bk) ? [] : (d.b || [])) : [];
      if (!z.length) return;
      var ime = p.etiket.charAt(0).toLowerCase() + p.etiket.slice(1);
      chasti.push({ za: ime.indexOf('за ') === 0 ? ime : 'за ' + ime, bilki: izbroj(z) });   /* граматика */
    });
    if (!chasti.length) return '';
    var parva = slot === SLOT_EDINICHNA;
    var glagol = ' ' + (parva ? T_SV1 : T_SV2) + ' ';
    var red = chasti.map(function (c, i) {
      return (i === 0 ? c.za.charAt(0).toUpperCase() + c.za.slice(1) + glagol : c.za + ' - ') + c.bilki;
    }).join(', а ');   /* граматика */
    return red + (parva ? '.' : ' - ' + T_SV_KRAY + '.');
  }

  function kartaTekstove() {
    try {
      var blok = koren.querySelector('[data-br-kviz-tekstove]');
      if (!blok) return null;
      var karta = JSON.parse(blok.textContent);
      if (typeof karta === 'string') karta = JSON.parse(karta);
      return karta;
    } catch (e) { return null; }
  }

  function pokazhiObyasnenie(obshto) {
    var kutia = koren.querySelector('[data-br-kviz-obyasnenie]');
    if (!kutia) return;
    var formi = izbraniFormi();
    var izbrani = izbraniPod();
    var karta = kartaTekstove();
    var pd = (karta && karta.p) || {};
    var fd = (karta && karta.f) || {};
    var tekst = '';

    if (formi.length === 1) {
      var slot = formi[0].tekst;
      var mnogo = ((fd[formi[0].kluch] || {}).m || '').trim();
      /* Текст по ПОДОБЛАСТ и форма (най-точното); при няколко избрани
         подобласти той би бил верен само за първата, затова там се ползва
         общият за формата („Текст при няколко подобласти"). */
      if (izbrani.length === 1 && pd[izbrani[0].kluch]) {
        tekst = ((pd[izbrani[0].kluch].t || {})[slot] || '').trim();
      } else if (izbrani.length > 1) {
        /* Няколко подобласти (16.09): първо билките на Наталия за всяка от
           тях („За X най-често се търсят ..."), после общият текст за формата. */
        tekst = svarzvasht(karta, izbrani, slot);
        tekst += (tekst ? ' ' : '') + mnogo;
      }
      /* Резерва: подобласт без свой текст за тази форма - общият на формата.
         Резервните текстове на областите отпаднаха на 01.10.2026 - не излизаха
         при нито една комбинация. */
      if (!tekst) tekst = mnogo;
    } else if (formi.length > 1) {
      /* Няколко форми наведнъж (Наталия, 14.09). Текстовете са писани за ЕДНА
         форма и всеки твърди своя бройка - слети биха лъгали. Затова един ред,
         който казва само проверимото: колко продукта и в кои форми, а след
         него - най-често избираните за всяка форма, взети от нейния текст
         (Симеон, 16.09: „защо не е имплементирано"). */
      var imenaFormi = formi.map(function (f) {
        var ime = (fd[f.kluch] || {}).i;
        return (ime || f.etiket || '').toLowerCase();
      });
      tekst = T_POKAZVAME.replace('{formi}', izbroj(imenaFormi));
      /* билките на Наталия са едни и същи за всички форми (16.09) - излизат
         веднъж, не по веднъж на форма */
      var dop = svarzvasht(karta, izbrani, SLOT_KOMBINACII);
      if (dop) tekst += ' ' + dop;
    }

    var imena = izbrani.map(function (p) { return p.etiket; }).filter(Boolean);
    /* бройката НЕ е закована в текста - идва от data-obshto на върнатите
       секции, тоест от каталога в момента на заявката (Симеон, 11.09) */
    if (typeof obshto === 'number' && obshto > 0) {
      tekst = tekst.replace(/\{broy\}/g, obshto);
    } else {
      tekst = tekst.replace(/\s*са \{broy\}\./g, '.').replace(/\{broy\}/g, '');
    }
    kutia.textContent = '';
    if (imena.length) {
      var izbor = document.createElement('strong');
      izbor.className = 'br-kviz__obyasnenie-izbor';
      izbor.textContent = T_IZBRA.replace('{imena}', izbroj(imena));
      kutia.appendChild(izbor);
    }
    if (tekst) {
      kutia.appendChild(document.createTextNode((imena.length ? ' ' : '') + tekst));
    }
    kutia.hidden = !(tekst || imena.length);
  }

  /* РАЗНООБРАЗИЕ ПО ФОРМА (Симеон, 16.09). При две или повече избрани форми
     редът на колекцията би напълнил 12-те места с първата форма - при „всичко"
     за Детокс това са 12 насипни билки и нито една тинктура. Затова картите
     се РЕДУВАТ по форма, а вече подредени: първо всички Билков рай през
     формите, после чуждите марки през формите. Вътре във всяка форма редът
     остава по релевантност (покритие) и продажби. */
  /* Марката е доставчикът: data-marka = product.vendor от 01.10 (R2), както и
     data-prodavach. Сравнението е точно - „Билкова аптека" НЕ е наша марка. */
  function nashaMarka(k) {
    var m = (k.dataset.marka || k.dataset.prodavach || '').toLowerCase().replace(/®/g, '').trim();
    return m.indexOf('билков рай') === 0 ? 0 : 1;   /* данни, не текст */
  }
  function izcherpanaKarta(k) { return k.querySelector('.t4-karta--izcherpan') ? 1 : 0; }

  /* имената в продуктите на билките на избраните подобласти - полето „Как е
     изписана в продуктите" на записите „Въпросник · Билка" (k в данните) */
  function kanonZa(podove) {
    var karta = kartaTekstove();
    var pd = (karta && karta.p) || {};
    var imena = {}, broy = 0;
    (podove || []).forEach(function (p) {
      ((pd[p.kluch] || {}).k || []).forEach(function (x) { if (!imena[x]) { imena[x] = 1; broy++; } });
    });
    return { imena: imena, broy: broy };
  }

  /* P9 (16.09): от продукт, отворен оттук, „Обратно към резултатите" -
     продуктовата страница чете този запис (snippets/t4-kviz-vrashtane.liquid) */
  grid.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;
    try {
      /* собствена котва: по нея пускането разбира, че това е връщане, и пази избора (16.10) */
      sessionStorage.setItem('br-kviz:ot', JSON.stringify({ u: location.pathname + location.search + '#vaprosnik-rezultati', v: Date.now() }));
    } catch (err) { /* частен режим */ }
  });

  /* „Виж всички в …“ - към коя подобласт излиза човекът от резултата (19.10.2026) */
  vsichki.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (a) analitika('kviz_vizh_vsichki', { kviz_podoblasti: a.dataset.brPodoblast || '', transport_type: 'beacon' });
  });

  function stoynostiNaFormata(parametri) {
    return parametri.split('&').map(function (dvoika) {
      var i = dvoika.indexOf('=');
      return i < 0 ? '' : decodeURIComponent(dvoika.slice(i + 1).replace(/\+/g, ' '));
    }).filter(Boolean);
  }

  function razmesiPoFormi(podredeni) {
    var formi = izbraniFormi();
    if (formi.length < 2) return podredeni;
    var grupi = formi.map(function (f) { return { stoynosti: stoynostiNaFormata(f.parametri), redici: [[], []] }; });
    var bezForma = [[], []];
    podredeni.forEach(function (k) {
      var negovi = (k.dataset.forma || '').split('|').filter(Boolean);
      var koshnica = null;
      for (var g = 0; g < grupi.length && !koshnica; g++) {
        if (negovi.some(function (v) { return grupi[g].stoynosti.indexOf(v) >= 0; })) koshnica = grupi[g].redici;
      }
      var stepen = izcherpanaKarta(k) ? 1 : nashaMarka(k);
      (koshnica || bezForma)[stepen].push(k);
    });
    var izhod = [];
    [0, 1].forEach(function (stepen) {
      var ostava = true;
      while (ostava) {
        ostava = false;
        grupi.forEach(function (g) {
          if (g.redici[stepen].length) { izhod.push(g.redici[stepen].shift()); ostava = true; }
        });
      }
      izhod = izhod.concat(bezForma[stepen]);
    });
    return izhod;
  }

  /* НИЩО НЕ ЗАМРЪЗВА (Симеон, 16.09). Три пътя оставяха бутона на „Търся…"
     завинаги: грешка при разбора в then() (без catch), мрежа, която не връща
     нищо, и връщане назад в страницата посред заявката (bfcache пази DOM-а
     с изключен бутон). Затова: catch + пазач по време + pageshow. */
  var tarsya = 0;
  function otpusni() {
    tarsya = 0;
    butonNapred.textContent = stapka === 3 ? T_POKAZHI : T_NAPRED;
    prover();
  }

  /* МЯСТОТО НА РЕЗУЛТАТА СЕ ЗАЕМА ПРИ ДОКОСВАНЕТО (CLS, 18.10.2026). Резултатът е много по-висок от стъпка 3
     и идваше чак след отговорите на сървъра - на бавен телефон 0,7-1,5 s след „Покажи продуктите“, тоест
     след 500-те ms, в които браузърът прощава преместването, и всичко под въпросника слизаше надолу
     (Shopify, „Ефективност“: CLS 0,27 на „По оплакване“ и 0,23 на областите). Затова синхронно, още в
     обработката на докосването: стъпка 3 се скрива, на мястото на резултата застава празно място с
     височината на екрана и въпросникът отива най-горе. Картите сменят мястото в същата задача, в която се
     показват, тоест мести се само съдържание извън екрана. Мястото е едно и се маха при всеки изход -
     резултат, грешка, 20-те секунди, връщане от bfcache посред заявката и „Отначало“.
     Доклад: Workbench/skorost/18-10/DOKLAD.md, П0. */
  var rezerva = null;
  function mahniRezerva() {
    if (rezerva && rezerva.parentNode) rezerva.parentNode.removeChild(rezerva);
    rezerva = null;
  }
  function zaemiMyastoto() {
    mahniRezerva();
    rezerva = document.createElement('div');
    rezerva.className = 'br-kviz__rezerva';
    rezerva.setAttribute('aria-hidden', 'true');
    rezerva.style.height = window.innerHeight + 'px';
    paneli3().forEach(function (p) { p.hidden = true; });
    napredak.hidden = true;
    /* при възстановяване („Назад“ без bfcache) pokazhi() вече е показал празния резултат - и той чака под мястото */
    rezultat.hidden = true;
    rezultat.parentNode.insertBefore(rezerva, rezultat);
    /* след мястото, не преди него: къса страница иначе не стига, за да дойде въпросникът най-горе */
    (koren.closest('#vaprosnik') || koren).scrollIntoView({ block: 'start' });
  }

  function pokazhiRezultat() {
    var podove = izbraniPod();
    if (!podove.length) return;
    butonNapred.disabled = true;
    butonNapred.textContent = T_TARSYA;
    zaemiMyastoto();
    var tozi = ++tarsya;
    setTimeout(function () {
      if (tarsya === tozi && butonNapred.textContent === T_TARSYA) {
        /* 20 секунди без отговор: показваме каквото има и връщаме бутона */
        mahniRezerva();
        prazno.hidden = grid.children.length > 0;
        stapka = grid.children.length > 0 ? 4 : 3;
        pokazhi();
        otpusni();
      }
    }, 20000);
    /* обяснението чака бройката - рисува се в края на then-а */

    /* една заявка на колекция; редът с няколко колекции дава няколко заявки */
    var zayavki = [];
    podove.forEach(function (p, pi) {
      p.vsichki.forEach(function (d, di) { zayavki.push({ pi: pi, drazhka: d, parva: di === 0 }); });
    });
    Promise.all(zayavki.map(function (z) {
      return fetch(adres(z.drazhka, true))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (tela) {
      var parser = new DOMParser();
      var videni = {};
      var karti = [];
      var poStranici = {};   /* бройката на всяка колекция - веднъж, по дръжка (за {broy}) */
      var docs = tela.map(function (html) { return html ? parser.parseFromString(html, 'text/html') : null; });
      /* ЗАКАЧЕНИТЕ И СКРИТИТЕ (решението от 01.10.2026) идват в същия отговор -
         .t4-kviz-podbor по подобласт. Събират се първо, защото подобласт с две
         колекции ги носи и в двата отговора; важи първият.
         „Кога важат закачените" (data-sastoyanie): vkl - винаги; proba - само в
         прегледа на редактора на темата (Shopify.designMode); izkl - никога.
         Скритите важат винаги. */
      var vRedaktora = !!(window.Shopify && window.Shopify.designMode);
      var podbor = {};
      docs.forEach(function (doc) {
        if (!doc) return;
        doc.querySelectorAll('.t4-kviz-podbor').forEach(function (g) {
          var kl = g.dataset.podoblast;
          if (!kl || podbor[kl]) return;
          var skriti = {};
          (g.dataset.skriti || '').split(',').filter(Boolean).forEach(function (h) { skriti[h] = 1; });
          var vazhat = g.dataset.sastoyanie !== 'izkl' && (g.dataset.sastoyanie !== 'proba' || vRedaktora);
          podbor[kl] = { skriti: skriti, samo: vazhat && g.dataset.nachin === 'samo',
                         parvi: vazhat ? Array.prototype.slice.call(g.querySelectorAll('.t4-kviz-rez__el')) : [] };
        });
      });
      /* формите на картата сред избраните (индекси) - по тях се решава и
         закаченият продукт, и „Само тези" */
      var formiIzbrani = izbraniFormi().map(function (f) { return stoynostiNaFormata(f.parametri); });
      function formiNaKarta(k) {
        var negovi = (k.dataset.forma || '').split('|').filter(Boolean);
        var out = [];
        formiIzbrani.forEach(function (st, fi) {
          if (negovi.some(function (v) { return st.indexOf(v) >= 0; })) out.push(fi);
        });
        return out;
      }
      /* „Как се ползват закачените: Само тези" е ПО ФОРМА: за всяка подобласт -
         кои от избраните форми имат закачен продукт. Там излизат само
         закачените; форма без закачени остава автоматична. */
      var samoFormi = {};
      podove.forEach(function (p) {
        var pb = podbor[p.kluch];
        if (!pb || !pb.samo) return;
        var sf = {};
        pb.parvi.forEach(function (k) {
          if (!pb.skriti[k.dataset.handle]) formiNaKarta(k).forEach(function (fi) { sf[fi] = 1; });
        });
        samoFormi[p.kluch] = sf;
      });
      docs.forEach(function (doc, i) {
        if (!doc) return;
        var kutia = doc.querySelector('.t4-kviz-rez');
        /* Бройката се СЪБИРА от всички колекции на подобластта, не се взима
           само от първата. Старото `if (parva)` даваше числото на първата
           колекция, а списъкът идваше от всички - при 13-те подобласти с по
           две колекции това показваше 0 продукта при 153 в списъка
           (одит, 11.09). Продукт, който е в двете колекции, се брои два пъти -
           надценява с единици, докато старото подценяваше с всичко. */
        var broi_tuk = kutia ? parseInt(kutia.dataset.obshto, 10) || 0 : 0;
        var pi = zayavki[i].pi;
        podove[pi].obshto = (podove[pi].obshto || 0) + broi_tuk;
        /* Общата бройка ({broy}) брои всяка страница ВЕДНЪЖ (Симеон, 05.10.2026:
           „Поправи броенето"). Две подобласти могат да сочат към една и съща
           колекция - „Стрес, напрежение и безсъние" и „Невралгия и периферни
           нерви" - и тогава отговорът ѝ идва по веднъж за всяка; сборът по
           подобласти удвояваше числото. Числото в „Виж всички (N)" остава
           бройката на своята подобласт. */
        poStranici[zayavki[i].drazhka] = broi_tuk;
        if (!kutia) return;
        /* videni[handle] пази ОТ КОИ подобласти (индексите им) е дошъл
           продуктът - редът „защо е тук" под името го казва на купувача.
           „Никога не показвай тук" маха продукта само за своята подобласт. */
        var skriti = (podbor[podove[pi].kluch] || {}).skriti || {};
        var samo = samoFormi[podove[pi].kluch];
        kutia.querySelectorAll('.t4-kviz-rez__el').forEach(function (el) {
          var h = el.dataset.handle;
          if (skriti[h]) return;
          if (samo) {
            /* „Само тези": продуктът отпада за тази подобласт, ако всичките му
               избрани форми имат закачени */
            var fk = formiNaKarta(el);
            if (fk.length && fk.every(function (fi) { return samo[fi]; })) return;
          }
          if (videni[h]) {
            if (videni[h].indexOf(pi) < 0) videni[h].push(pi);
            return;
          }
          videni[h] = [pi];
          karti.push(el);
        });
      });

      /* Подреждане на резултата - три критерия по тежест (Симеон, 11.09:
         „продуктите трябва да са възможно най-подходящите спрямо избраното,
         както и винаги приоритизирай продуктите на Билков рай"):

           1. КОЛКО от избраните подобласти покрива продуктът. Ако някой е
              избрал „Стомах" и „Черен дроб", продукт, който стои и в двете,
              е по-подходящ от такъв само в едната. videni[handle] вече пази
              точно този списък.
           2. Билков рай(R) преди чуждите марки.
           3. изчерпаните най-накрая - няма смисъл да заемат първите редове.

         Вътре в еднаквите остава редът от заявката, а той е по продажби. */
      var red = {};
      karti.forEach(function (k, i) { red[k.dataset.handle] = i; });
      var izcherpan = izcherpanaKarta;
      var nash = nashaMarka;
      function pokritie(k) { return (videni[k.dataset.handle] || []).length; }
      /* РЕЛЕВАНТНОСТ (Симеон, 16.09: „винаги първо билков рай - най-релевантните
         неща, после другите марки"): колко от билките, които Наталия е посочила
         за избраните подобласти, стоят в продукта (data-bilki срещу имената им в
         продуктите - записите „Въпросник · Билка"). */
      var kanon = kanonZa(podove);
      function relevantnost(k) {
        if (!kanon.broy) return 0;
        var b = (k.dataset.bilki || '').split('|'), n = 0;
        for (var i = 0; i < b.length; i++) { if (b[i] && kanon.imena[b[i]]) n++; }
        return n;
      }
      var podredeni = karti.slice().sort(function (a, b) {
        /* РЕДЪТ НА КРИТЕРИИТЕ (Симеон, 12.09: „при всяка една възможна
           комбинация да излизат първо билков рай продукти"): марката е ПРЕД
           всичко друго; вътре в марката - първо продуктите с билките на
           Наталия за избраното, после покритието на подобластите, накрая
           редът на колекцията (по продажби). Изчерпаните са най-отзад. */
        return izcherpan(a) - izcherpan(b)
            || nash(a) - nash(b)
            || relevantnost(b) - relevantnost(a)
            || pokritie(b) - pokritie(a)
            || red[a.dataset.handle] - red[b.dataset.handle];
      });
      var avtomatichni = razmesiPoFormi(podredeni);

      /* ЗАКАЧЕНИТЕ ОТПРЕД (Симеон 01.10.2026: „ръчно да си ги избира за всяка
         една възможна комбинация, но иначе ... автоматично"): в техния ред,
         редувани между избраните подобласти (първият на всяка, после
         вторият...). Излиза само закачен продукт от избраните форми - така една
         подобласт държи свои първи продукти за всяка форма. Скритото печели пред
         закаченото; изчерпаните закачени - най-отзад. */
      var zakacheni = [], zakacheniIzch = [], otZakachane = {};
      var nay = 0;
      podove.forEach(function (p) { nay = Math.max(nay, ((podbor[p.kluch] || {}).parvi || []).length); });
      for (var m = 0; m < nay; m++) {
        podove.forEach(function (p, pi) {
          var pb = podbor[p.kluch];
          var k = pb && pb.parvi[m];
          if (!k) return;
          var h = k.dataset.handle;
          if (pb.skriti[h]) return;
          if (!formiNaKarta(k).length) return;
          if (otZakachane[h]) {
            if (otZakachane[h].indexOf(pi) < 0) otZakachane[h].push(pi);
            return;
          }
          otZakachane[h] = [pi];
          (izcherpanaKarta(k) ? zakacheniIzch : zakacheni).push(k);
        });
      }
      var izbrani = zakacheni
        .concat(avtomatichni.filter(function (k) { return !otZakachane[k.dataset.handle]; }))
        .concat(zakacheniIzch)
        .slice(0, BROY);

      grid.innerHTML = '';
      izbrani.forEach(function (k) {
        /* t4-animacii крие всяка .t4-karta (opacity 0) до появата ѝ в екрана;
           наблюдателят му не знае за вмъкнатите отвън карти - показваме ги сами */
        k.querySelectorAll('.t4-karta').forEach(function (karta) { karta.classList.add('t4-vidim'); });
        var h = k.dataset.handle;
        var ot = (otZakachane[h] || []).slice();
        (videni[h] || []).forEach(function (pi) { if (ot.indexOf(pi) < 0) ot.push(pi); });
        dobaviZashto(k, ot.map(function (pi) { return podove[pi].etiket; }),
                     ot.map(function (pi) { return podove[pi].cel; }));
        grid.appendChild(k);
      });
      prazno.hidden = izbrani.length > 0;

      vsichki.innerHTML = '';
      podove.forEach(function (p) {
        var a = document.createElement('a');
        a.href = adres(p.drazhka, false);
        a.dataset.brPodoblast = p.etiket || '';
        var buton = document.createElement('span');
        buton.className = 't4-buton t4-buton--vtori';
        buton.textContent = T_VIZH_BUTON;
        var ime = document.createElement('span');
        ime.className = 'br-kviz__vsichki-ime';
        ime.textContent = T_VIZH.replace('{ime}', p.etiket) + (p.obshto ? ' (' + p.obshto + ')' : '');
        a.appendChild(buton);
        a.appendChild(ime);
        vsichki.appendChild(a);
      });

      var obshto = 0;
      Object.keys(poStranici).forEach(function (d) { obshto += poStranici[d]; });
      pokazhiObyasnenie(obshto);

      /* показаният резултат (връщането към него не е нов резултат) и списъкът с картите - към GA4 */
      if (!vrashtane) analitika('kviz_rezultat', { kviz_broy: izbrani.length });
      try { if (window.brAnalitika && window.brAnalitika.spisatsi) window.brAnalitika.spisatsi(grid); } catch (err) { /* измерването */ }

      mahniRezerva();
      stapka = 4;
      pokazhi();
      zapishi();
      otpusni();
      if (vrashtane) { vrashtane = false; kamVaprosnika(); }
    }).catch(function () {
      /* разборът или мрежата паднаха: оставаме на стъпка 3 с работещ бутон */
      analitika('kviz_greshka');
      mahniRezerva();
      prazno.hidden = false;
      stapka = 3;
      pokazhi();
      otpusni();
    });
  }

  /* Връщане назад към страницата от bfcache: DOM-ът идва замръзнал в
     състоянието от момента на тръгването - понякога с „Търся…" и изключен
     бутон. Отпускаме всичко и, ако резултатът липсва, го изграждаме пак. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    koren.querySelectorAll('input[name="br-glavna"], input[name="br-forma"]').forEach(function (ch) { ch.disabled = false; });
    paneli2().forEach(function (p) { limitPod(p); });
    /* заявката е прекъсната посред път: празното място си отива, стъпката пак е видима */
    if (rezerva) { mahniRezerva(); pokazhi(); }
    otpusni();
    if (stapka === 4 && !grid.children.length && izbraniPod().length) pokazhiRezultat();
  });

  /* Пускане: ако има запазено състояние - връщаме го. На стъпка 4 резултатът
     се изгражда наново от живия каталог, не от запазени карти: наличностите и
     цените се менят, а старите карти биха лъгали. */
  var vrashtane = false;
  var predizbrana = koren.dataset.brPredizbrana;
  /* Ново влизане (менюто, плочка, връзка, презареждане) започва отначало (Наталия, 16.10);
     паметта важи само при връщане - „Назад“ на браузъра или „Обратно към резултатите“. */
  var navVhod = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : null;
  var vrashtaSe = (navVhod ? navVhod.type === 'back_forward'
                           : !!(window.performance && performance.navigation && performance.navigation.type === 2))
                  || location.hash === '#vaprosnik-rezultati';
  if (!vrashtaSe) zabravi();
  if (vazstanovi()) {
    if (stapka === 4) {
      vrashtane = true;
      pokazhi();
      pokazhiRezultat();
    } else {
      pokazhi();
      kamVaprosnika();
    }
  } else if (predizbrana !== undefined && predizbrana !== '') {
    /* Страница на област „По оплакване": плочката е дадена от адреса, тръгваме
       от подобластите. Без превъртане - човекът тепърва вижда страницата. */
    var dadena = koren.querySelector('input[name="br-glavna"][value="' + predizbrana + '"]');
    if (dadena) { dadena.checked = true; stapka = 2; }
    pokazhi();
  } else {
    pokazhi();
  }

  /* Пускането свърши: от тук видът го решават атрибутите hidden. До този миг CSS-ът на
     секцията (.br-kviz--js:not(.br-kviz--gotov)) я държи във вида след скрипта, та да няма скок. */
  var sekcia = koren.closest('.br-kviz');
  if (sekcia) sekcia.classList.add('br-kviz--gotov');
})();
